import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { DataContext } from "../../components/Context";
import Ddata from "../../components/discount/Ddata";
import "./Header.css"
const Head = () => {

  const { logoSlider, baseImage } = useContext(DataContext);
  return (
    <>
      <section className="head">
        <div className="left_head_container LText">
          <div className="flex_head">
            {
              logoSlider.slice(0, 7).map((value, index) => {
                return (
                  <div key={index} className="logo_product">
                    <div className="img-marcas">
                      <img className="marcas-header" src={baseImage + value.imagen} alt={value.imagen} width={"60px"} />
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
        <div className="right_head_container RText">
          <div className="flex_head">
           <div className="flex-socialmedia-telegram-gmail">
           {/* <div className="flex-telegram">
            <i className="fab fa-telegram"></i>
            <h5 className="laconsola-telegram">@LaConsola</h5>
            </div> */}

       
            <div className="flex-telegram">
            <i className="fa fa-envelope"></i>
            <h5 className="mail-container">laconsolamendoza@gmail.com</h5>
            </div>
           </div>
            <div className="link-terminosH">
              <Link to="/terminos">Términos Y Condiciones</Link></div>
            <a
              href="https://wa.me/542612565651"
              target="_blank"
              className="ayuda-link"
            >
              <span>Ayuda</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Head;
